import { http } from "./client";

// Storefront query functions.  All of them go through the FastAPI proxy and
// return the flattened product shape produced server-side (id, handle, title,
// productType, tags, availableForSale, featuredImage, images, priceRange,
// compareAtPriceRange, firstVariant { availableForSale, price, compareAtPrice }).

export async function productsList({ first = 20, after = null } = {}) {
  const params = { first };
  if (after) params.after = after;
  const { data } = await http.get("/shopify/products", { params });
  return data; // { products, pageInfo, count }
}

export async function productByHandle(handle) {
  const { data } = await http.get(
    `/shopify/product/${encodeURIComponent(handle)}`,
  );
  return data; // flattened product
}

export async function collectionByHandle(handle, { first = 12 } = {}) {
  const { data } = await http.get(
    `/shopify/collection/${encodeURIComponent(handle)}`,
    { params: { first } },
  );
  return data; // { exists, handle, title, products, count, ... }
}

// Bestsellers — single criterion server-side: the exact, case-sensitive
// Shopify tag `bestseller`. No collection cascade, no latest-products
// fallback. Uppercase variants ("Bestseller", "BEST Seller") do NOT match.
export async function productsForBestsellers({ first = 8 } = {}) {
  const { data } = await http.get("/shopify/bestsellers", { params: { first } });
  return data; // { source, products, count }
}

// Try each handle in order, return the first collection that returns products.
// Falls back to productsList when nothing yields.
export async function productsInCollection(handles = [], { first = 12 } = {}) {
  const list = Array.isArray(handles) ? handles : [handles];
  for (const h of list) {
    try {
      const res = await collectionByHandle(h, { first });
      if (res && res.exists && res.products && res.products.length > 0) {
        return { source: `collection:${h}`, products: res.products, count: res.count };
      }
    } catch {
      // ignore and try next
    }
  }
  const latest = await productsList({ first });
  return { source: "products:latest", products: latest.products, count: latest.count };
}

// `collectionsList` is not exposed by the current proxy explicitly; the health
// endpoint is enough for now, and the storefront constants file works with
// slug lookups.  When Prompt 2 (PLPs) lands the backend will grow a
// /shopify/collections endpoint and this can be uncommented.
export async function collectionsList(/* first = 50 */) {
  // Placeholder for forward-compat.  Returns an empty list today so UI can
  // gracefully render "—" counts.
  return [];
}
